export const REQUIRED_FIELD_MESSAGE = 'Esse campo é obrigatório'
export const strMaxLenMessage = size => `Esse campo aceita no máximo ${size || 255} caracteres`
export const WARRANTY_MONTHS_ERROR_MESSAGE = 'O valor deve ser entre 0 e 12'
export const NUMERIC_FIELD_MESSAGE = 'Esse campo deve ser numérico'
export const REQUIRED_MATERIAL_MESSAGE = 'O item deve ter valor e quantidade válidos'
export const CEP_FIELD_MESSAGE = 'CEP inválido'
